import { render, staticRenderFns } from "./move-project.vue?vue&type=template&id=0b8bac31"
import script from "./move-project.vue?vue&type=script&lang=js"
export * from "./move-project.vue?vue&type=script&lang=js"
import style0 from "./move-project.vue?vue&type=style&index=0&id=0b8bac31&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports